import React from 'react';
import Icon from '../../../components/AppIcon';

const TermsOfService = () => {
  const termsData = {
    lastUpdated: '23 Septembre 2025',
    sections: [
      {
        title: '1. Acceptation des Conditions',
        content: `En accédant et en utilisant la plateforme KAPITALSTATES, vous acceptez d'être lié par ces Conditions d'Utilisation et toutes les lois et réglementations applicables en Côte d'Ivoire. Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser ce service.`
      },
      {
        title: '2. Services de la Plateforme',
        content: `KAPITALSTATES fournit une plateforme numérique pour:
        • La recherche et la consultation de propriétés immobilières
        • Les services de mise en relation avec des notaires agréés
        • Les visites virtuelles par vidéo immersive
        • L'assistance juridique pour les transactions immobilières
        • La gestion des rendez-vous et consultations`
      },
      {
        title: '3. Responsabilités des Utilisateurs',content: `En tant qu'utilisateur, vous vous engagez à:
        • Fournir des informations exactes et à jour
        • Respecter les droits de propriété intellectuelle
        • Ne pas utiliser la plateforme à des fins illégales
        • Maintenir la confidentialité de vos identifiants de connexion
        • Respecter les conditions d'utilisation des services de notaires partenaires`
      },
      {
        title: '4. Propriétés et Annonces',
        content: `Concernant les propriétés listées:
        • Toutes les informations sont fournies à titre informatif
        • KAPITALSTATES ne garantit pas l'exactitude des détails des propriétés
        • Les prix et disponibilités peuvent changer sans préavis
        • Vérification obligatoire auprès des notaires partenaires avant tout engagement`
      },
      {
        title: '5. Services Notariaux',
        content: `Les services de notaires sont fournis par des professionnels agréés:
        • KAPITALSTATES agit uniquement comme intermédiaire
        • Tous les actes légaux relèvent de la responsabilité du notaire
        • Les frais de notaire sont définis selon le barème officiel ivoirien
        • Les rendez-vous sont confirmés directement par l'étude notariale`
      },
      {
        title: '6. Résolution des Litiges',
        content: `En cas de différend:
        • Tentative de résolution amiable obligatoire
        • Médiation par un organisme agréé si nécessaire
        • Juridiction compétente: Tribunaux d'Abidjan, Côte d'Ivoire
        • Droit applicable: Droit ivoirien en matière immobilière`
      }
    ]
  };

  return (
    <div className="p-8">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-12 h-12 bg-brand-gold/10 rounded-xl flex items-center justify-center">
          <Icon name="FileText" size={24} color="var(--color-brand-earth)" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl text-brand-earth">
            Conditions d'Utilisation
          </h2>
          <p className="text-gray-600 text-sm">
            Dernière mise à jour: {termsData?.lastUpdated}
          </p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-blue-600)" />
          <div>
            <p className="text-blue-800 text-sm font-medium">
              Important: Ces conditions régissent l'utilisation de la plateforme KAPITALSTATES 
              et les relations avec nos partenaires notariaux agréés en Côte d'Ivoire.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        {termsData?.sections?.map((section, index) => (
          <div key={index} className="border-l-4 border-brand-gold pl-6">
            <h3 className="font-heading font-semibold text-xl text-brand-earth mb-4">
              {section?.title}
            </h3>
            <div className="text-gray-700 leading-relaxed whitespace-pre-line">
              {section?.content}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 p-6 bg-brand-earth/5 rounded-xl">
        <h3 className="font-heading font-semibold text-brand-earth mb-3">
          Contact Légal
        </h3>
        <p className="text-gray-700 text-sm mb-4">
          Pour toute question concernant ces conditions d'utilisation, contactez notre service juridique:
        </p>
        <div className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-6 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Mail" size={16} color="var(--color-brand-earth)" />
            <span>legal@kapitalstates.com</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Phone" size={16} color="var(--color-brand-earth)" />
            <span>+225 21 50 00 53 18</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;